export default {
	state: {
		problemId: "",
		 projectId: "",
		handleProjectId: "",
		lookorupdate: "",
		handleShowProjectId: "",
	},
	mutations: {
		setProblemId(state, problemId) {
			state.problemId = problemId
		},
		setProjectId(state, projectId) {
			state.projectId = projectId
		},
		setHandleProjectId(state, handleProjectId) {
			state.handleProjectId = handleProjectId
		},
		setLookorupdate(state, lookorupdate) {
			state.lookorupdate = lookorupdate
		},
		setHandleShowProjectId(state, handleShowProjectId) {
			state.handleShowProjectId = handleShowProjectId
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js